import { Reducer } from "../../lib/redux";
import TripAnnotation from "../../model/TripAnnotation";
import { extend } from "../../utils/vanilla";
import { TripAnnotationActions } from "./actions";
import { TripAnnotationActionTypes } from "./types";

export let defaultTripAnnotations: IIdDictionary<IIdDictionary<TripAnnotation>> = {};

export let tripAnnotations: Reducer<IIdDictionary<IIdDictionary<TripAnnotation>>, TripAnnotationActions> = (state = defaultTripAnnotations, action) => {
        switch (action.type) {
            case TripAnnotationActionTypes.SET_TRIPANNOTATIONS: {
                    const deviceId = action.payload.deviceId;
                    if (deviceId) {
                        return {
                            ...state,
                            [deviceId]: extend(true, {}, action.payload.tripAnnotations)
                        };
                    }
                    return state;
                }
            case TripAnnotationActionTypes.CLEAR_TRIPANNOTATIONS:
                return {};
            default:
                return state;
        }
};